import { sanitize } from '../url_helpers'

const configGoogleAnalytics4 = (measurementId) => (
  // GA4 with gtag
  window.gtag('config', measurementId, {
    cookie_domain: 'auto',
    cookie_flags: 'SameSite=None; Secure',
    send_page_view: false
  })
)

const setLocation = (trackerName, url) => {
  const sanitizedUrl = sanitize(url)
  // GA4 with gtag
  // format for page_location https://developers.google.com/analytics/devguides/collection/ga4/reference/config#page_location_ex
  window.gtag('set', 'page_location', sanitizedUrl)
}

const setReferrer = (trackerName, url) => {
  const sanitizedUrl = sanitize(url)
  // GA4 with gtag
  // format for page_referrer https://developers.google.com/analytics/devguides/collection/ga4/reference/config#page_referrer
  window.gtag('set', 'page_referrer', sanitizedUrl)
}

const trackEvent = (trackerName, eventCategory, eventAction, eventLabel, eventValue) => {
  // GA4 with gtag
  window.gtag('event', eventAction, {
    event_category: eventCategory,
    event_label: eventLabel,
    value: eventValue
  })
}

export const Service = {
  configureGA4(measurementId) {
    configGoogleAnalytics4(measurementId)
  },
  userTrackEvent(eventAction, eventLabel, eventValue) {
    setLocation('user', window.location.href)
    setReferrer('user', window.location.href)

    trackEvent('user', 'Calendly', eventAction, eventLabel, eventValue)
  }
}
